export default __webpack_public_path__ + "static/media/Arabic.14382410.gif";